var A = /* @__PURE__ */ ((r) => (r.CARD = "card", r.DASHBOARD = "dashboard", r))(A || {});
export {
  A as RocheUITeaserCardLayout
};
